import useLocalStorage from './useLocalStorage';

export default function useSavedPreferencesWithCustomKey<TType = any>(
    key: string
): [Partial<TType>, (preferences: Partial<TType>) => void] {
    const [preferences, save] = useLocalStorage(key, {});
    const savePreferences = partial => save({ ...preferences, ...partial });

    return [preferences, savePreferences];
}
